import { z } from "zod";

export enum TroubleType {
  ON_HOLD = "ON_HOLD",
  MISMATCH = "MISMATCH",
  ERROR = "ERROR",
}

export const TroubleEntrySchema = z.object({
  active: z.boolean(),
  type: z.string(),
  source: z.string().optional(),
  value: z.string().optional(),
  comments: z.array(z.string()).optional(),
});

export const TroubleDataSchema = z
  .array(TroubleEntrySchema)
  .nullable()
  .optional();

export type TroubleEntry = z.infer<typeof TroubleEntrySchema>;
export type TroubleData = z.infer<typeof TroubleDataSchema>;
